import React, { useEffect, useState, useRef } from "react";

const VideoPlayer = ({ videoUrl }) => {
    const [videoId, setVideoId] = useState(null);
    const iframeRef = useRef(null);

    useEffect(() => {
        const extractYouTubeVideoId = (url) => {
            try {
                const urlObj = new URL(url);
                if (urlObj.hostname.includes("youtu.be")) {
                    return urlObj.pathname.substring(1);
                }
                return (
                    urlObj.searchParams.get("v") ||
                    url.match(/embed\/([a-zA-Z0-9_-]{11})/)?.[1]
                );
            } catch (error) {
                return null;
            }
        };

        if (videoUrl) {
            const extractedId = extractYouTubeVideoId(videoUrl);
            setVideoId(extractedId);
        }
    }, [videoUrl]);

    const iframeUrl = videoId
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1`
        : "";

    return (
        <div className="video-player">
            {videoId ? (
                <iframe
                    ref={iframeRef}
                    width="100%"
                    height="100%"
                    src={iframeUrl}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="YouTube Video Player"
                ></iframe>
            ) : (
                <p style={{ textAlign: "center", padding: "20px" }}>
                    No valid video URL found.
                </p>
            )}
        </div>
    );
};

export default VideoPlayer;
